
class RuntimeGameData {
    constructor() {
        this.sortTrainData = {
            onStation: {

            },
            onLoad: {

            }
        }
    }
    getSortTrainData(){
        return this.sortTrainData;
    }
    clear(){
        this.sortTrainData.onLoad = {};
        this.sortTrainData.onStation = {};
    }

}

const CurrentGame = new RuntimeGameData();

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    RuntimeGameData,
    CurrentGame
};
